import React from 'react';

const ReferralIcon = ({ size = 24, color = '#000' }) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 512.000000 512.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill={color}
        stroke="none"
      >
        <path
          d="M1011 4910 c-327 -46 -593 -272 -693 -590 -20 -66 -23 -95 -23 -235
       0 -182 15 -248 86 -386 185 -357 616 -531 998 -403 127 42 216 99 321 204 144
       144 215 287 241 489 38 282 -97 594 -331 766 -163 120 -404 182 -599 155z"
        />
        <path
          d="M3457 3674 c-431 -78 -772 -406 -869 -836 -28 -128 -29 -327 0 -454
       97 -432 416 -744 852 -836 135 -28 354 -21 488 16 182 50 329 135 466 266 336
       323 429 819 232 1236 -61 129 -116 206 -220 309 -165 164 -350 261 -574 300
       -98 18 -274 17 -375 -1z"
        />
        <path
          d="M292 3186 c-192 -206 -292 -475 -292 -787 l0 -109 1116 0 1117 0 -6
       168 c-5 181 -19 255 -77 399 -48 120 -119 229 -228 353 l-40 45 -34 -31 c-83
       -78 -247 -171 -377 -213 -123 -40 -212 -54 -351 -54 -259 -1 -478 72 -687 229
       l-82 62 -59 -62z"
        />
        <path
          d="M0 1395 l0 -585 697 0 698 0 -88 -88 c-48 -48 -87 -92 -87 -97 0 -6
       46 -56 103 -113 l102 -102 278 278 277 277 -273 273 c-149 149 -277 272 -282
       272 -13 0 -205 -192 -205 -205 0 -5 42 -51 92 -102 l93 -93 -553 0 -552 0 0
       435 0 435 -150 0 -150 0 0 -585z"
        />
        <path
          d="M2709 1486 c-212 -175 -371 -409 -459 -675 -50 -151 -69 -271 -72
       -456 l-3 -150 1473 -3 1472 -2 0 118 c0 473 -193 891 -546 1179 l-50 42 -85
       -61 c-145 -104 -332 -185 -519 -225 -129 -27 -441 -25 -566 5 -201 47 -404
       142 -545 253 l-36 28 -64 -53z"
        />
      </g>
    </svg>
  );
};

export default ReferralIcon;
